module.exports = __webpack_public_path__ + "static/nanoleaf-logo-d54b36b47fed89a7fe1ef3fff62965c7.png";